import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class QuanlybaocaoService {
  APIURL_Chung = "api/ExcuteOracle"
  constructor(
    public api: ApiService
  ) {


  }
  public p_laydanhsach_baocao(tukhoa, danhmucid, loaibaocao, tungay, denngay, pagenum, numrec) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAO.P_GET_BAOCAO","connstr":"Amiss42"}',
      "para": '{"v_keyword":"' + tukhoa + '","v_danhmucid":"' + danhmucid + '","v_loaibaocao":"' + loaibaocao + '","v_tungay":"' + tungay + '","v_denngay":"' + denngay + '","v_pagenum":"' + pagenum + '","v_numrecs":"' + numrec + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  public xoaBaoCao(id) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAO.P_XOA_BAOCAO","connstr":"Amiss42"}',
      "para": '{"v_ID":"' + id + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/quan-ly-bao-cao/quanlybaocao.service.ts